import React from "react";
import {
  FaArrowLeft,
  FaArchive,
  FaTrash,
  FaEnvelope,
  FaEllipsisV,
  FaHome,
  FaBox,
} from "react-icons/fa";
import translations from "../../translation"; // Import translations

const EmailScreen = ({ content, title, name, attachment, language }) => {
  const translate = (key) => translations[language][key] || key; // Translation function

  // Function to detect the text direction
  const detectDirection = (text) => {
    const rtlRegex = /[\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC]/; // Detect RTL characters
    return rtlRegex.test(text) ? "rtl" : "ltr";
  };

  const direction = detectDirection(content || ""); // Detect direction from the content

  return (
    <div
      className="email-screen bg-light"
      style={{
        maxWidth: "400px",
        margin: "0 auto",
        border: "1px solid #ddd",
        fontFamily: "'Roboto', sans-serif",
        borderRadius: "10px",
        overflow: "hidden",
      }}
    >
      {/* Header */}
      <div
        className="email-header d-flex align-items-center justify-content-between"
        style={{
          backgroundColor: "#fff",
          padding: "15px 15px",
        }}
      >
        <div className="d-flex align-items-center">
          <FaArrowLeft style={{ fontSize: "18px", cursor: "pointer" }} />
        </div>
        <div className="d-flex align-items-center">
          <FaArchive style={{ fontSize: "18px", margin: "0 10px", cursor: "pointer" }} />
          <FaTrash style={{ fontSize: "18px", margin: "0 10px", cursor: "pointer" }} />
          <FaEnvelope style={{ fontSize: "18px", margin: "0 10px", cursor: "pointer" }} />
          <FaEllipsisV style={{ fontSize: "18px", marginLeft: "10px", cursor: "pointer" }} />
        </div>
      </div>

      {/* Title Section */}
      <div
        className="email-title d-flex align-items-center justify-content-between bg-white pb-4 pt-3"
        style={{
          padding: "10px 15px",
        }}
      >
        <div className="d-flex align-items-center">
          <div
            className="logo"
            style={{
              width: "40px",
              height: "40px",
              backgroundColor: "#fff",
              borderRadius: "50%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "#1f73cc",
              fontWeight: "bold",
              fontSize: "30px",
              border: "1px solid #1f73cc",
              textTransform: "uppercase",
            }}
          >
            A
          </div>
          <div style={{ marginLeft: "10px" }}>
            <h5
              style={{
                margin: 0,
                fontSize: "14px",
                fontWeight: "bold",
                textTransform: "capitalize",
                direction, // Apply detected direction
                textAlign: direction === "rtl" ? "right" : "left",
              }}
            >
              {title || translate("defaultTitle")}
            </h5>
            <p
              style={{
                margin: 0,
                fontSize: "12px",
                color: "#4285F4",
                textTransform: "capitalize",
                direction, // Apply detected direction
                textAlign: direction === "rtl" ? "right" : "left",
              }}
            >
              {name || translate("defaultName")}
            </p>
          </div>
        </div>
        <FaEllipsisV style={{ fontSize: "18px", cursor: "pointer" }} />
      </div>

      {/* Company Name */}
      <div
        className="email-company"
        style={{
          padding: "10px 15px",
          borderBottom: "1px solid #ddd",
          backgroundColor: "#f8f9fa",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          className="logo"
          style={{
            width: "30px",
            height: "30px",
            backgroundColor: "#1f73cc",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "#fff",
            fontWeight: "bold",
            fontSize: "20px",
            textTransform: "uppercase",
          }}
        >
          A
        </div>
        <p
          style={{
            margin: 0,
            fontSize: "20px",
            fontWeight: "bold",
            color: "#1f73cc",
            marginLeft: "10px",
          }}
        >
          {translate("companyName")}
        </p>
      </div>

      {/* Content Section */}
      <div
        className="email-body"
        style={{
          padding: "15px",
          backgroundColor: "#fff",
          minHeight: "390px",
          direction, // Apply detected direction
          textAlign: direction === "rtl" ? "right" : "left", // Align based on direction
        }}
      >
        <div
          style={{
            whiteSpace: "pre-wrap",
            wordWrap: "break-word",
            overflowWrap: "break-word",
            fontSize: "14px",
            color: "#444",
            lineHeight: "1.6",
            marginBottom: "10px",
            textTransform: "capitalize",
          }}
          dangerouslySetInnerHTML={{ __html: content || translate("defaultContent") }}
        />
        {attachment && attachment.type.startsWith("image/") && (
          <div className="attachment-preview">
            <img
              src={attachment.url}
              alt={translate("attachmentAlt")}
              style={{
                maxWidth: "100%",
                borderRadius: "5px",
                marginTop: "10px",
              }}
            />
          </div>
        )}
        {attachment && attachment.type === "application/pdf" && (
          <div
            className="pdf-preview"
            style={{
              marginTop: "10px",
              padding: "10px",
              border: "1px solid #ddd",
              borderRadius: "5px",
              backgroundColor: "#f9f9f9",
              textAlign: "center",
            }}
          >
            <p style={{ margin: 0, fontSize: "14px", color: "#555" }}>
              {translate("pdfAttachmentLabel")}: {attachment.name}
            </p>
          </div>
        )}
      </div>

      {/* Footer */}
      <div
        className="email-footer d-flex justify-content-between"
        style={{
          backgroundColor: "#f1f3f4",
          padding: "10px 10px",
          borderTop: "1px solid #ddd",
        }}
      >
        <button
          className="btn"
          style={{
            color: "#333",
            fontSize: "20px",
            padding: "5px 15px",
          }}
        >
          <FaArrowLeft />
        </button>
        <button
          className="btn"
          style={{
            color: "#333",
            fontSize: "20px",
            padding: "5px 15px",
          }}
        >
          <FaHome />
        </button>
        <button
          className="btn"
          style={{
            color: "#333",
            fontSize: "14px",
            padding: "5px 15px",
          }}
        >
          <FaBox />
        </button>
      </div>
    </div>
  );
};

export default EmailScreen;
